const BASEURL = "https://bookingapi.tajwaycabs.com/api/";
// const BASEURL = `http://15.207.172.209:5000/api/`;
// const BASEURL = `http://localhost:5063/api/`;

const API_URL = {
  BASEURL: BASEURL,

  postLogin: "v1/webAuth/login",

  getRoleList: "v1/webRole",
  getRoleFilterSet: "v1/webRole/filterSet",

  //---users
  getUserFilterSet: "v1/webUser/filterSet",
  getUserById: "v1/webUser",
  createUser: "v1/webUser",
  updateUser: "v1/webUser",
  getVendorList: "v1/webUser/vendors",
  getDriverList: "v1/webUser/drivers",
  addVendorAmount: "v1/Transaction/VenderAmmount",
  getVendorAmountList: "v1/Transaction/VenderAmmount/FilterSet",

  //----booking
  getBookingFilterSet: "v1/webBooking/filterSet",
  getBookingById: "v1/webBooking",
  createBooking: "v1/webBooking",
  updateBooking: "v1/webBooking",
  activeInactiveBooking: "v1/webBooking/activeInActive",

  //----booking status
  getBookingStatusFilterSet: "v1/webBookingStatus/filterSet",
  getBookingStatusList: "v1/webBookingStatus",
  getBookingStatusById: "v1/webBookingStatus",
  updateBookingStatus: "v1/webBookingStatus",

  //----booking type
  getBookingTypeList: "v1/webBookingTypes",

  //----car
  getCarFilterSet: "v1/webCar/filterSet",
  getCarList: "v1/webCar",

  //----terms&Conditions
  getTermsConditionsFilterSet: "v1/webApp/termsConditions/filterSet",
  getTermsConditionById: "v1/webApp/termsConditions",
  createTermsCondition: "v1/webApp/termsConditions",
  updateTermsCondition: "v1/webApp/termsConditions",

  //----policy
  getPolicyFilterSet: "v1/webApp/policies/filterSet",
  getPolicyById: "v1/webApp/policy",
  createPolicy: "v1/webApp/policy",
  updatePolicy: "v1/webApp/policy",

  //----panaltyStructure
  getPanaltyStructureFilterSet: "v1/webApp/panaltyStructures/filterSet",
  getPanaltyStructureById: "v1/webApp/panaltyStructure",
  createPanaltyStructure: "v1/webApp/panaltyStructure",
  updatePanaltyStructure: "v1/webApp/panaltyStructure",

  getDashboard: "v1/admin/customer/dashaboard",
  getCustomerReq: "v1/admin/salon/list-new",
  updateServiceReq: "v1/admin/salon/update/servicestatus",
  serviceReqDetail: "v1/admin/salon/list-details",

  getCategory: "v1/category/list",
  deleteCategory: "v1/category/deletecategory",
  updateCategory: "v1/category/updatecategory",
  createCategory: "v1/category/createcategory",
  createServices: "v1/services/createservices",
  categoryDetail: "v1/category/fetchcategory",

  updateServices: "v1/services/updateservice",
  getServiceList: "v1/services/list",
  getServiceByCategory: "v1/services/listbycategory",
  serviceDetail: "v1/services/servicedetail",

  getSlonlist: "v1/admin/salon/list",
  getSalonDetail: "v1/admin/salon/salondetails",
  updateSalon: "v1/admin/salon/updatesalon",
  updateSalonStatus: "v1/admin/salon/update/status",
  getsalonCategory: "v1/admin/salon/saloncategorylist",
  getSalonCategoryServices: "v1/admin/salon/salonservices",
  approveSalon: "v1/admin/salon/verify/account",
  postRegister: "v1/admin/salon/register",
  postSalonImage: "v1/admin/salon/salonimage",
  postUserDelete: "v1/user/delete",
  // postLoginStaff : 'https://hims.abymtech.com/new/abha-sdk/PatientsController/patientsvisitlist',

  getStaff: "v1/admin/getstaff",
  getStaffDetails: "v1/admin/getstaffdetail",

  postCreateStaff: "v1/admin/createstaff",
  postUpdateStaff: "v1/admin/updatestaff",
  postDeleteStaff: "v1/admin//delete/staff",

  postCreateRole: "v1/admin/createrole",
  postRoleCopy: "v1/admin/getroles",
  postUpdateRole: "v1/admin/updaterole",
  // postDeleteRole

  uploadImg: "v1/upload/add",

  getBanner: "v1/admin/banner/getAll",
  createBanner: "v1/admin/banner/create",
  updateBanner: "v1/admin/banner/update",
  bannerDetails: "v1/admin/banner/get/detail",
  BannerPathidDetails: "v1/admin/banner/get/list",
  bannerDelete: "v1/admin/banner/delete",

  getVideo: "v1/videos/video-list",
  deletevideo: "v1/video/deletevideo",
  updatevideo: "v1/videos/video-update",
  createVideo: "v1/videos/video-add",
  videoDetail: "v1/videos/video-detail",
  uploadThumbnail: "v1/upload/add",

  getCustomerList: "v1/admin/customer/list",
  getCustomerDetails: "v1/admin/customer/customer-details",
  getTransactionList: "v1/admin/rewardpoint/list",
  // customerRatingDelete:'v1/admin/customer/ratting-delete',
  statusUpdate: "v1/admin/customer/update-status",

  uploadImg: "v1/upload/add",

  getRole: "v1/admin/getroles",
  createRole: "v1/admin/createrole",
  updateRole: "v1/admin/updaterole",
  roleDetail: "v1/admin/getroles/details",
  moduleDetails: "v1/admin/module/filterdata",
  createPermissionRole: "v1/admin/add/permission",
  appointment: "v1/admin/customer/appoiment-list",
  appointmentDetails: "v1/admin/customer/appoiment-detail",

  createSalonUser: "v1/admin/salon/register/salonuser",
  createSalon: "v1/admin/salon/register/salon",
  saloonImageUpload: "v1/admin/salon/images/upload",
  createSalonAddress: "v1/admin/salon/register/salonaddress",
  getSalonServiceList: "v1/admin/salon/salonservices",

  getRating: "v1/admin/customer/ratting/list",
  postDeleteRating: "v1/admin/customer/ratting/delete",
  postRatingStatusUpdate: "v1/admin/customer/update/rating/status",
};

export default API_URL;
